<template>
  <div
    :class="[{open}, (context && context.attributes) ? context.attributes.class : '']"
    class="popup"
  >
    <div class="popup-flex scroll">
      <div class="close-popup" @click="close" />
      <div
        :class="(context && context.attributes && context.attributes.windowClass) ? context.attributes.windowClass : 'window-480'"
        class="window"
      >
        <div class="close w-inline-block">
          <div class="icon-24px">
            <CloseIcon @click="close" />
          </div>
        </div>
        <component :is="component" :context="context" />
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import CloseIcon from '@/icons/close.svg';

  export default {
    name: 'Modal',
    components: {CloseIcon},
    computed: {
      ...mapState({
        component: state => state.modal.component,
        context: state => state.modal.context,
        open: state => state.modal.open,
      }),
    },
    watch: {
      open (val) {
        if (val) document.body.style.overflowY = 'hidden';
        else document.body.style.overflowY = 'auto';
      },
    },
    methods: {
      ...mapActions({
        close: 'modal/closeModal',
      }),
    },
  };
</script>

<style lang="scss">
  .popup {
    display: block !important;
    visibility: hidden;
    opacity: 0;
    transition: opacity .3s, visibility .3s;

    &.open {
      visibility: visible;
      opacity: 1;
      transition: opacity .3s;
    }

    .close {
      cursor: pointer;
    }
  }
</style>
